import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import { FIRST_IMAGE_FEATURE } from '../../../DaEditorWrapper/Features';
import { getFeature } from '../../../DaEditorWrapper/Features/helper';
import BackgroundImage from '../../BackgroundImage';
import MediaService from '../../../utils/DeviationMediaService';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import s from './Commission.scss';
function getCoverImageFile(deviation, showMatureContent) {
    const { textContent, commission } = deviation;
    let coverImage = deviation.coverImage;
    if (!coverImage) {
        if (textContent && textContent.html.type === 'draft') {
            const first = getFeature(FIRST_IMAGE_FEATURE, textContent.html.features);
            if (first) {
                coverImage = first.data.deviation;
            }
        } else if (commission) {
            if (commission.examples && commission.examples.length) {
                coverImage = commission.examples[0];
            }
        }
    }
    if (coverImage && coverImage.isMature && !showMatureContent) {
        return null;
    }
    return coverImage && MediaService.getLargestFullview(coverImage);
}
export const CommissionStageBackground = ({ deviation })=>{
    const showMatureContent = useContext(MatureContext);
    const isMobile = useContext(MobileContext);
    const coverImage = getCoverImageFile(deviation, showMatureContent);
    if (!coverImage) {
        return /*#__PURE__*/ React.createElement(EmptyBackground, {
            className: s['empty-background']
        });
    }
    const { src } = coverImage;
    return /*#__PURE__*/ React.createElement(BackgroundImage, {
        src: src,
        fade: isMobile ? false : 'full-strong',
        subtleBlur: !isMobile
    });
};
CommissionStageBackground.displayName = 'CommissionStageBackground';
export default CommissionStageBackground;
